<template>
  <div>
    <my-courses-desktop v-if="screenType === 'desktop'"></my-courses-desktop>
    <my-courses-mobile v-else></my-courses-mobile>
  </div>
</template>

<script>
import MyCoursesDesktop from "@/components/Pages/Desktop/Dashboard/Lessons/MyCoursesDesktop";
import MyCoursesMobile from "@/components/Pages/Mobile/Dashboard/Lessons/MyCoursesMobile";

export default {
  name: "LessonMain",
  components: {MyCoursesMobile, MyCoursesDesktop},
  data() {
    return {
      screenType: window.screen.width < 500 ? 'mobile' : window.screen.width < 1000 ? 'tablet' : 'desktop'
    }
  },
  mounted() {
    this.getSubscriptionInfo()
  },
  methods: {
    getSubscriptionInfo() {
      window.axios.get('student/subscriptions/my').then((res) => {
        if (!res.data.data.subscriptions.length) {
          this.openSnackbar('اشتراک معتبری یافت نشد.لطفا اشتراک تهیه کنید.', '#F1416C')
          let self = this
          window.setTimeout(function () {
            self.$router.push('/dashboard/subscriptions')
          }, 3000)
        }
      })
    }
  }
}
</script>

<style scoped>

</style>